export default __webpack_public_path__ + "static/media/Caviar.174b0a13.ttf";